import client from './client';
import requestCatchError from './requestCatchError';

const request = async (method, path, body = null, params = {}) => {
  try {
    const response = await client[method](path, body, params);
    return response;
  } catch (error) {
    return requestCatchError(error);
  }
};

export default {
  get: (path, params) => {
    let fullPath = path;

    if (params) {
      const urlParams = new URLSearchParams(params).toString();
      if (urlParams) fullPath += `?${urlParams}`;
    }

    return request('get', fullPath, params);
  },
  post: (path, body, params) => request('post', path, body, params),
  patch: (path, body) => request('patch', path, body),
  put: (path, body) => request('put', path, body),
  delete: (path, params) => request('delete', path, params),
};
